<template>
    <administrative>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Branch</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Branch Code'"/>
                            <breeze-input required v-model="form.code" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.code:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Branch Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Address Line 1'"/>
                            <breeze-input required v-model="form.address_line_1" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.address_line_1:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :value="'Address Line 2'"/>
                            <breeze-input v-model="form.address_line_2" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.address_line_2:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Landmark'"/>
                            <breeze-input required v-model="form.landmark" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.landmark:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'City'"/>
                            <breeze-input required v-model="form.city" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.city:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'State'"/>
                            <breeze-input required v-model="form.state" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.state:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Pincode'"/>
                            <breeze-input required v-model="form.pincode" type="number" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.pincode:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Mobile'"/>
                            <breeze-input required v-model="form.mobile" type="number" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.mobile:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Email'"/>
                            <breeze-input required v-model="form.email" type="email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.email:''"/>
                        </div>
                        <hr class="col-span-8 sm:col-span-8"/>
                        <p class="text-lg font-medium col-span-8 sm:col-span-8">Bank Details</p>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Account Name'"/>
                            <breeze-input required v-model="form.account_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.account_name:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Bank Name'"/>
                            <breeze-input required v-model="form.bank_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.bank_name:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Bank Branch'"/>
                            <breeze-input required v-model="form.bank_branch" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.bank_branch:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Account No'"/>
                            <breeze-input required v-model="form.account_no" type="number" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.account_no:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'IFSC Code'"/>
                            <breeze-input required v-model="form.ifsc_code" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.ifsc_code:''"/>
                        </div>
                        <hr class="col-span-8 sm:col-span-8"/>
                        <p class="text-lg font-medium col-span-8 sm:col-span-8">Study Center Head</p>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Head Name'"/>
                            <breeze-input required v-model="form.head_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.head_name:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Head Mobile'"/>
                            <breeze-input required v-model="form.head_mobile" type="number" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.head_mobile:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Head Email'"/>
                            <breeze-input required v-model="form.head_email" type="email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.head_email:''"/>
                        </div>
                        <p class="text-lg font-medium col-span-8 sm:col-span-8">Study Center Coordinator</p>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Coordinator Name'"/>
                            <breeze-input required v-model="form.coordinator_name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.coordinator_name:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Coordinator Mobile'"/>
                            <breeze-input required v-model="form.coordinator_mobile" type="number"
                                          class="w-full appearance-none"/>
                            <breeze-input-error :message="form.errors?form.errors.coordinator_mobile:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Coordinator Email'"/>
                            <breeze-input required v-model="form.coordinator_email" type="email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.coordinator_email:''"/>
                        </div>
                    </div>
                    <button-link :href="route('administrative.branch.list')" class="bg-red-500 mr-4 hover:bg-red-400">
                        Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Next</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </administrative>
</template>

<script>
import Administrative from '@/Pages/Administrative/Administrative'
import BreezeTable from '@/Components/Table'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'

export default {
    components: {
        Administrative,
        BreezeTable,
        ButtonLink,
        Exception,
        BreezeInputError,
        BreezeInput,
        BreezeLabel,
        BreezeButton,
        Loading
    },
    props: ['products'],
    data() {
        return {
            form: useForm({
                code: '',
                title: '',
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                pincode: '',
                landmark: '',
                mobile: '',
                email: '',
                account_name: '',
                bank_name: '',
                bank_branch: '',
                account_no: '',
                ifsc_code: '',
                head_name: '',
                head_mobile: '',
                head_email: '',
                coordinator_email: '',
                coordinator_name: '',
                coordinator_mobile: '',
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('administrative.branch.store'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
    }
}
</script>
